import React, {  useState } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { registerUser } from '../../redux/actions/auth';




const Signup =(props)=> {
    const initData = {
        pre_heading: "Signup",
        heading: "Create an Account",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit."
    }
    
    const [state, setState] = useState({
        name: '',
        email: 'admin@demo.com',
        password: '123456',
      })
    const changeCred = (event) => {
        setState({ ...state, [event.target.name]: event.target.value })
      }
    const doRegister = (event) => {
        event.preventDefault();
        if (!state.name || !state.email || !state.password) {
         
          return
        }
        props.dispatch(registerUser({
            creds: state,
            history: props.history,
          }))
    }
  
        return (
            <section className="author-area">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-7">
                            {/* Intro */}
                            <div className="intro text-center">
                                <span>{initData.pre_heading}</span>
                                <h3 className="mt-3 mb-0">{initData.heading}</h3>
                                <p>{initData.content}</p>
                            </div>
                            {/* Item Form */}
                            <form className="item-form card no-hover" onSubmit={(event => doRegister(event))}>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input onChange={(event) => changeCred(event)} type="text" className="form-control" name="name" placeholder="Enter your Name" required />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input onChange={(event) => changeCred(event)} type="email" className="form-control" name="email" placeholder="Enter your Email" required />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group mt-3">
                                            <input onChange={(event) => changeCred(event)} type="password" className="form-control" name="password" placeholder="Enter your Password" required />
                                        </div>
                                    </div>
                                    
                                    <div className="col-12">
                                        <button className="btn w-100 mt-3 mt-sm-4" type="submit">Sign Up</button>
                                    </div>
                                    <div className="col-12">
                                        <span className="d-block text-center mt-4">Already have an account? <Link to="/login">Login</Link></span>
                                    </div>
                                    <div className="col-12">
                                        <hr />
                                       
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        );
    
}



function mapStateToProps(state) {
    return {
      
      isAuthenticated: state.auth.isAuthenticated,
      
    };
  }
  
  export default withRouter(connect(mapStateToProps)(Signup));